import { render, staticRenderFns } from "./LanguageNew.vue?vue&type=template&id=3a427382&"
import script from "./LanguageNew.vue?vue&type=script&lang=js&"
export * from "./LanguageNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports